export default "__VITE_ASSET__6iXn8ssP__"